<script setup lang="ts">
import { formatInTimeZone } from 'date-fns-tz';

import KParentTooltip from '@/components/tooltips/KParentTooltip.vue';
import * as commonConstants from '@/constants/common';

export interface Props {
  updatedAt?: string | null;
}
const props = withDefaults(defineProps<Props>(), {
  updatedAt: undefined,
});

const timeZone = 'Australia/Sydney';

function formatDate(date: string, timeZone: string): string {
  return formatInTimeZone(date, timeZone, 'hh:mm a, MMM d'); // 04:50 PM, Sep 24
}
</script>

<template>
  <dl
    :class="$style.detailedJobLastUpdatedDescList"
    data-testid="detailedJobLastUpdatedDescList"
  >
    <dt :class="$style.term">
      <KParentTooltip location="bottom" :offset="3">
        Latest job history record time
      </KParentTooltip>
      Last activity
    </dt>
    {{ ' ' }}
    <dd :class="$style.details">
      <template v-if="props.updatedAt">
        <KParentTooltip location="bottom" :offset="3">
          {{ props.updatedAt }}
        </KParentTooltip>
        {{ formatDate(props.updatedAt, timeZone) }}
      </template>
      <template v-else>{{ commonConstants.EM_DASH }}</template>
    </dd>
  </dl>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.detailedJobLastUpdatedDescList {
  margin: 0;
}
  .term {
    display: inline;
    color: colors.$color-text-tertiary;
  }
  .details {
    display: inline;
    margin: 0;
    color: colors.$color-text-secondary;
  }
</style>
